export default __webpack_public_path__ + "static/media/logo3.01511a87.png";